import React from 'react';
import  './../style/style.css';
import ReconnectingWebSocket from 'reconnecting-websocket';
import {endCall} from './../service.js';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Config from './../config.js';
import { EventEmitter } from 'events';
import PeerConnection from './peerconnection';
import RecordingRTCPeerConnection from './recrtcpeerconnection';
import Div100vh from 'react-div-100vh';

const PING_INTERVAL = 15000;

class Customer extends React.Component {
  constructor(props) {
    super(props);
    this.videoTag = null;
    this.videoTagRemote = null;
    this.canvasTag = null;
    this.id = "";
    this.photoTag = null;
    this.peerConnection = null;
    this.iceQueue = [];
    this.answered = false;
    this.recordedBlobs = [];
    this.recordingStarted = false;
    this.devices = null;
    this.isIOS = false;
    this.pingSent = 0;
    this.pongReceived = 0;
    this.remoteStream = null;
    this.eventEmitter = new EventEmitter();
    this.recEventEmitter = new EventEmitter();
    this.recPeerconnection = new RecordingRTCPeerConnection(false, this.eventEmitter);
    this.recEventEmitter.on('recDispatchMessage', (message) =>{
      this.sendMessage(message);
    });
    this.remoteStreamTimeoutOne = null;
    this.remoteStreamTimeoutTwo = null;
    this.isIOS = false;
    this.microphone = null;
    this.camera = null;
    this.flipcamera = null;
    this.cameraFacingMode = "";
    this.recordingToastID = null;
    this.webSocketToastId = -1;
    this.webSocketErrorStatus = null;
    this.state = {
      images: [],
      callstate: "joined",
      endbuttondisabled : false,
      switchCamerabutton : false,
      camera: './images/camera-on.png',
      microphone: './images/microphone-on.png',
      recordingText : "",
      isReconnecting : false
    };
    this.handleConnectionChange = this.handleConnectionChange.bind(this);
  }

  componentDidMount() {
    console.log(navigator.mediaDevices  + ": " + navigator.mediaDevices.enumerateDevices);
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (
      navigator.mediaDevices &&
      navigator.mediaDevices.enumerateDevices
    ) {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          console.log("Devices "+devices);
          this.init(devices);
        })
        .catch(function(err) {
          console.log(err.name + ": " + err.message);
        });
    }else{
      this.init(null);
    }
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);    

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  handleConnectionChange(event){
    console.log("Connection Change "+event.type);
  }  

  componentWillUnmount(){
    try{
      if(this.remoteStreamTimeoutOne){
        clearTimeout(this.remoteStreamTimeoutOne);
      }
      if(this.remoteStreamTimeoutTwo){
      clearTimeout(this.remoteStreamTimeoutTwo);
      }
    }catch(e){

    }
    window.removeEventListener('online', this.handleConnectionChange);
    window.removeEventListener('offline', this.handleConnectionChange);    
  }

  ping() {
    const message = {
      id: 'ping',
      callID: this.props.callID
    };
    this.sendMessage(message);
    this.pingSent++;
    if(this.rws)
      console.log("Reconnecting web socket "+this.rws.readyState);

    if(this.rws.readyState === 1){
      /*if(toast.isActive(this.webSocketToastId)){
        toast.dismiss(this.webSocketToastId);
        this.webSocketToastId = -1;
      }*/
      if(this.state.isReconnecting)
        this.setState({isReconnecting: false});
    }

    if((this.pingSent -this.pongReceived) >= 2){
      this.rws.reconnect(100, "reconnect");

      console.log("Resetting ping count");
      this.pingSent = 0;
      this.pongReceived = 0;
    }    
    console.log("ping Sent " +  this.pingSent);
    if(this.peerConnection && this.peerConnection.getPeerConnectionState() === "connected"){
      this.setState({isReconnecting : false});
    }
  }


  render() {
    const { t } = this.props;
    if (this.state.callstate === "ended"){
      return (
        <Div100vh>
        <div className="PageTitle">
        	<div className="Header">{t('videophone_title')}</div>
      	</div>
        <div className="BodyStyle">
          <div className="BodyText">
          {t('call_ended')}
          </div>
        </div>
      </Div100vh>
      );
    }else if (this.state.callstate === "error"){
      return (
        <Div100vh>
        <div className="PageTitle">
        	<div className="Header">{t('videophone_title')}</div>
      	</div>
        <div className="BodyStyle">
          <div className="BodyText">
          {t('invalid_call_url')}
          </div>
        </div>
      </Div100vh>
      );
    }
    else {
      return (
        <Div100vh>
          {this.state.isReconnecting?<div className="Reconnecting">{t('connecting')}</div>:null}
          <div className="PageTitle">
            <div className="Header">{t('videophone_title')}</div>
          </div>
          <ToastContainer />
          <div className="BodyStyle">
            <div className="VideoCallHeader">
            <div className="SubTitleWrapper">
              <div className="SubTitle">{t('video_call')}</div>
              </div>
              <div className="SubTitleWrapper">
              <div className="SubTitleCenter">{this.state.recordingText}</div>
              </div>
              <div className="TitleButtonWrapper">
                <button
                  className="TitleButtonStyle"
                  onClick={event => {
                    this.handleEndCall(true);
                  }}
                  id="end_id"
                >
                  {t('end')}
                </button>
              </div>
            </div>
            <div className="VideoContentCustomer">
              <video
                id="localvideo"
                className="videoTag"
                ref={ref => {
                  this.videoTag = ref;
                }}
                autoPlay
                muted
                playsInline
              />
              <video
                hidden
                id="remoteVideo"
                ref={ref => {
                  this.videoTagRemote = ref;
                }}
                playsInline
                autoPlay
              />
            </div>
            <div className="VideoCallFooter">
              <div className="ImageContainerLeft">
                <img
                  key="unmuted"
                  className="iconStyle"
                  src={this.state.microphone}
                  alt=""
                  onClick={event => {
                    this.handleMicMute();
                  }}
                />
              </div>
              <div  className="ImageContainerRight">
                <img
                  key="cameraon"
                  className="iconStyle"
                  src={this.state.camera}
                  alt=""
                  onClick={event => {
                    this.handleCameraMute();
                  }}
                />
              </div>
              <div className={this.state.switchCamerabutton ? "ImageContainerRight" : "ImageContainerRightHidden"}>
                <img
                  className="iconStyle"
                  src="./images/flip-camera-icon.png"
                  alt=""
                  onClick={event => {
                    this.handleSwitchCamera();
                  }}
                />
              </div>
            </div>
          </div>
        </Div100vh>
      );
    }
  }

  handleCameraMute(){
    if(this.state.camera === "./images/camera-on.png"){
      this.mediaStream.getVideoTracks()[0].enabled = false;
      this.setState({camera: "./images/camera-off.png"});
    }else{
      this.mediaStream.getVideoTracks()[0].enabled = true;
      this.setState({camera: "./images/camera-on.png"});
    }
  }

  handleMicMute(){
    if(this.state.microphone ===  "./images/microphone-on.png"){
      this.mediaStream.getAudioTracks()[0].enabled = false;
      this.setState({microphone: "./images/microphone-off.png"});
    }else{
      this.mediaStream.getAudioTracks()[0].enabled = true;
      this.setState({microphone: "./images/microphone-on.png"});
    }
  }

  handleSwitchCamera(){
    this.setState({camera: "./images/camera-on.png", microphone : "./images/microphone-on.png"});
    var tempDeviceId =window.sessionStorage.getItem("WebcamDeviceId");
    for (var i = 0; i !== this.devices.length; ++i) {
      var deviceInfo = this.devices[i];
      if (
        deviceInfo.kind === "videoinput" &&
        deviceInfo.deviceId !== tempDeviceId
      ) {
        tempDeviceId =deviceInfo.deviceId;
        window.sessionStorage.setItem("WebcamDeviceId", deviceInfo.deviceId);
        break;
      }
    }


    if(this.peerConnection){
      this.peerConnection.stopTracks();
    }

    console.log("Swithc camera "+tempDeviceId);

    if(this.cameraFacingMode === "user"){
      this.cameraFacingMode = "environment";
    }else{
      this.cameraFacingMode = "user";
    }

    const constraints = {
      audio: {
        advanced: [{googEchoCancellation: {exact: true}}, {googAutoGainControl: {exact: true}}, {googNoiseReduction: {exact: true}}]
      },
      video: this.isIOS?
      {
        facingMode : this.cameraFacingMode,
        width: 1280,
        height: 720,
        frameRate : 10
      }:{
        deviceId: tempDeviceId ? { exact: tempDeviceId } : undefined,
        width: 1280,
        height: 720,
        frameRate : 10
      }
    };


    const handleChange = mediaStream => {
      try {
        if (this.videoTag) {
          this.videoTag.pause();
          this.videoTag.srcObject = null;
          this.videoTag.srcObject = mediaStream;
          this.mediaStream = mediaStream;
          this.videoTag.load();
          //this.setState({endbuttondisabled:false});
          if(this.recPeerconnection){
            this.recPeerconnection.switchTracks(mediaStream);
          }

          if(this.peerConnection){
            this.peerConnection.switchTracks(mediaStream);
          }
        }
      } catch (e) {
        console.error("handleChange error :", e);
      }
    };

    const errorCallback = err =>{
      console.error("Error :", err);
      toast(this.props.t("camera_switch_error")+ err, {
        type: toast.TYPE.WARNING,
        autoClose: 5000,
        hideProgressBar: true,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });

    }

    try {
      navigator.mediaDevices.getUserMedia(constraints).then(handleChange).catch(errorCallback);
    } catch (e) {
      console.error("navigator.getUserMedia error :", e);
    }


  }

  handleEndCall(bHandle){
    console.log("End Call");

    if(bHandle){
      endCall(this.props.token, false, (status)=>{
        if(status){
          this.setState({callstate : "ended"});

          this.peerConnection.close();
          this.peerConnection = null;
          this.recPeerconnection.close();
          this.eventEmitter.removeAllListeners();

            if(bHandle){
              const msg = {
                role: this.props.isCustomer ? "share" : "viewer",
                id: "endCall",
                userId: this.id,
                receiverId: this.receiverId,
                callID: this.props.callID
              };
              this.sendMessage(msg);
            }
        }
        this.rws.close();
      });
    }else{
      this.setState({callstate : "ended"});

      this.peerConnection.close();
      this.peerConnection = null;
      this.recPeerconnection.close();
      this.eventEmitter.removeAllListeners();
      this.rws.close();
    }
    clearInterval(this.pingInterval);
  }

  handleClick(event) {
    switch (event.currentTarget.dataset.id) {
      case "start_id":
        console.log("Start Call");
        this.setState({callstate : "joined", endbuttondisabled:true});
        break;

      case "capturecall_id":
        console.log("Capture screenshot");
        break;

      default:
        break;
    }
  }

  handleCapture(event) {
    var context = this.canvasTag.getContext("2d");
    this.canvasTag.width = 1280;
    this.canvasTag.height = 720;
    context.drawImage(
      this.videoTag,
      0,
      0,
      this.canvasTag.width,
      this.canvasTag.height
    );

    var data = this.canvasTag.toDataURL("image/png");
    var image = {};
    image.src = data;
    image.thumbnail = data;
    image.thumbnailWidth = 320;
    image.thumbnailHeight = 160;

    let imagesNew = this.state.images;
    imagesNew.push(image);
    this.setState({ images: imagesNew });

    //this.photoTag.setAttribute('src', data);
  }

  init(devices) {
    this.devices = devices;
    const options = {
      maxRetries: 1000
    };
    this.rws = new ReconnectingWebSocket(Config.wsUrl, [], options);
    this.pingInterval = setInterval(()=>this.ping(), PING_INTERVAL);
    this.rws.addEventListener("message", event => {
      //console.log(JSON.stringify(event));
      let message = JSON.parse(event.data);
      if(message.recording){
        this.handleRecordingMessage(event);
      }else{
        this.handleMessage(event);
      }
    });




    this.rws.addEventListener("error", event => {
      /* const toastOptions = {
        autoClose: false,
        type: toast.TYPE.WARNING,
        hideProgressBar: true,
        position: toast.POSITION.TOP_RIGHT,
        toastId: 101
      };
      if((this.webSocketToastId === 101) && toast.isActive(this.webSocketToastId)){
        // do nothing
      }else{
        if(this.webSocketToastId){
          toast.dismiss(this.webSocketToastId);
          this.webSocketToastId = -1;
        }
        this.webSocketToastId = toast("Error connecting to Videophone server... Retrying ...", toastOptions);
      }*/

      if(!this.state.isReconnecting)
        this.setState({isReconnecting: true});      

      console.log("Websocket error customer "+this.id +" "+event.type);
      console.log("Connection opened " + JSON.stringify(event));
    });

    this.rws.addEventListener("close", event => {

      console.log("Websocket closed customer "+this.id +" "+event.reason);
      console.log("Connection opened " + JSON.stringify(event));
    });

    this.rws.addEventListener("open", event => {
      /*if(toast.isActive(this.webSocketToastId)){
        toast.dismiss(this.webSocketToastId);
        this.webSocketToastId = -1;
      }*/
      if(this.state.isReconnecting)
        this.setState({isReconnecting: false}); 

      console.log("Connection opened " + JSON.stringify(event));
      let msg = {};
      msg.id = "JoinCall";
      msg.callID = this.props.callID;
      msg.userId = this.id;
      msg.userType = this.props.isCustomer ? "Customer" : "Agent";
      this.rws.send(JSON.stringify(msg), error => {
        if (error) {
          this.logger(
            `client: Websocket error '${error}' on message '${msg.id}'`,
            { topic: "ws" }
          );
        }
      });
    });


    if (this.props.isCustomer) {

        let videoCam = 0;
        console.log("Reached here " +devices);
        if (devices) {
          for (var i = 0; i !== devices.length; ++i) {
            var deviceInfo = devices[i];
            console.log("Reached here " +JSON.stringify(deviceInfo));
            if (
              deviceInfo.kind === "videoinput"
            ) {
              videoCam++;
            }
          }
        }

        this.setState({switchCamerabutton : videoCam>1?true: false});

      const constraints = {
        audio: {
          echoCancellation: { exact: true }
        },
        video: {
          facingMode : "environment",
          width: 1280,
          height: 720,
          frameRate : 10
        }
      };
      this.cmaeraFacingMode = "environment";

      const handleSuccess = mediaStream => {
        if(this.videoTag){
          this.videoTag.pause();
          this.videoTag.srcObject = mediaStream;
          this.mediaStream = mediaStream;
          this.recPeerconnection.setMediaStream(mediaStream);
          this.videoTag.load();
          //this.setState({endbuttondisabled:false});
          window.sessionStorage.setItem(
            "WebcamDeviceId",
            this.mediaStream.getVideoTracks()[0].getSettings().deviceId
          );

        }
      };

      const errorCallback = err =>{
        console.error("Error :", err);
      }

      try {
        navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess).catch(errorCallback);
      } catch (e) {
        console.error("navigator.getUserMedia error :", e);
      }
    }
  }

  handleMessage(event) {
    console.log("handleMessage:" + event.data);
    let message = JSON.parse(event.data);
    switch (message.id) {
      case "UserJoined":
        console.log("Users joined:" + event);
        this.id = message.userId;
        this.showToast(message.agentJoined, message.customerJoined);
        if (this.receiverId && this.props.isCustomer) {
          this.createWebRTCPeer();
        }
        break;

      case "CallStateChanged":
        if (message.userId !== this.id){
          if(message.msg === "CalleeJoined"){
            this.receiverId = message.userId;
          }
          this.showToast(message.agentJoined, message.customerJoined);
          if (this.receiverId && this.props.isCustomer) {
            if(message.msg !== "UserLeft"){
              this.createWebRTCPeer();
            }
          }
        }
        if(this.recPeerconnection.isRecordingOngoing() && !message.recordingstatus){
          this.handleRecordingMessageInternal({id : "onStopRecording"});
        }
        console.log("CallStateChanged " + this.receiverId);
        break;

      case "sdpOffer":
        if (!this.props.isCustomer) {
          this.createWebRTCPeer();
        }
        this.processOffer(message.sdpOffer);
        break;

      case "sdpAnswer":
        this.processAnswer(message.sdpAnswer);
        break;

      case "iceCandidate":
        this.handleIceCandidate(message.candidate);
        break;

        case "endCall":
            this.handleEndCall(false);
            break;

        case 'pong':
            this.pongReceived++;
            console.log("ping Received " +  this.pongReceived);
          break;

      case 'availableForCall':
          console.log("Peerconnection sender " +this.id +"receiverId "+ this.receiverId);
          if(this.peerConnection){
            console.log("Peerconnection status is "+ this.peerConnection.getPeerConnectionState());
          }else{
            console.log("Peerconnection is undefined")
          }
          if (this.receiverId && this.props.isCustomer) {
            if(this.peerConnection &&
              ((this.peerConnection.getPeerConnectionState()==="new") || (this.peerConnection.getPeerConnectionState()==="disconnected")
              || (this.peerConnection.getPeerConnectionState()==="failed"))){
              console.log("Peerconnection availableForCall closing peerConnection");
              this.peerConnection.closePeerConnection();
              this.eventEmitter.removeAllListeners();
              this.peerConnection = null;
            }
            this.createWebRTCPeer();
          }
        break;
          
      case "Error":
        this.setState({callstate : "error"});
        if(this.rws){
          this.rws.close();
        }
        break;

      default:
        break;
    }
  }

  handleRecordingMessage(event){
    let message = JSON.parse(event.data);
    this.handleRecordingMessageInternal(message);
  }

  handleRecordingMessageInternal(message){
    switch(message.id){
      case "onStartRecording":
          if(this.recordingToastID){
            toast.dismiss(this.recordingToastID);
          }
        this.recordingToastID = toast(this.props.t("rec_started"), {
            type: toast.TYPE.INFO,
            autoClose: 5000,
            hideProgressBar: true,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
          this.setState({recordingText: this.props.t("rec_in_progress")});
        break;

        case "onStopRecording":
            if(this.recordingToastID){
              toast.dismiss(this.recordingToastID);
            }          
          this.recordingToastID = toast(this.props.t("rec_stopped"), {
              type: toast.TYPE.INFO,
              autoClose: 5000,
              hideProgressBar: true,
              closeButton: null // The closeButton defined on ToastContainer will be used
            });
            this.setState({recordingText: ''});
          break;

          default:
            break;
    }

    this.recPeerconnection.handleMessage(message);

  }

  showToast(agentJoined, customerJoined){
    const options = {
      autoClose: false,
      type: toast.TYPE.INFO,
      hideProgressBar: true,
      position: toast.POSITION.TOP_RIGHT
    };

    if(this.toastId){
      toast.dismiss(this.toastId);
    }

    if(agentJoined && !customerJoined){
      this.toastId = toast(this.props.t("customer_join_wait"), options);
    }else if (!agentJoined && customerJoined){
      this.toastId = toast(this.props.t("agent_join_wait"), options);
    }
  }

  async createWebRTCPeer() {
    if(this.peerConnection)
      return;

    const offerOptions = {
      offerToReceiveAudio: 1,
      offerToReceiveVideo: 0
    };

    this.peerConnection = new PeerConnection(this.eventEmitter, offerOptions, this.mediaStream);
    this.recPeerconnection.set (this.recEventEmitter, offerOptions, this.mediaStream, this.props.callID, this.id);



    console.log("PeerConnection is "+ this.peerConnection);
    this.peerConnection.on('iceCandidate', (candidate)=>{
      const message = {
        type: "icecandidate",
        role: this.props.isCustomer ? "share" : "viewer",
        id: "iceCandidate",
        candidate: candidate,
        userId: this.id,
        callID: this.props.callID,
        receiverId: this.receiverId
      };
      this.sendMessage(message);
    });

    this.peerConnection.on("remoteStream", stream => {
      this.remoteStream = stream;
      this.videoTagRemote.srcObject = stream;

      try{
        if(this.remoteStreamTimeoutOne){
          clearTimeout(this.remoteStreamTimeoutOne);
        }

        if(this.remoteStreamTimeoutTwo){
          clearTimeout(this.remoteStreamTimeoutTwo);
        }
      }catch(e){

      }

      console.log("received remote stream");
      this.remoteStreamTimeoutOne = setTimeout(() => {
        try {
          this.mediaStream.getAudioTracks()[0].enabled = false;
          this.setState({ microphone: "./images/microphone-off.png" });
        } catch (e) {}

        this.remoteStreamTimeoutTwo = setTimeout(() => {
          try {
            this.mediaStream.getAudioTracks()[0].enabled = true;
            this.setState({ microphone: "./images/microphone-on.png" });
          } catch (e) {}
        }, 500);
        console.log("Toggling stream state");
      }, 10000);
    });

    this.peerConnection.on('onIceStateChange', (state)=>{
      if((state === "closed") || (state === "failed")){
        if(this.peerConnection){
          this.peerConnection.closePeerConnection();
          this.eventEmitter.removeAllListeners();
          this.peerConnection = null;
          const msg = {
            type: "icecandidate",
            role: this.props.isCustomer ? "share" : "viewer",
            id: "iceStateFailed",
            userId: this.id,
            callID: this.props.callID,
            receiverId: this.receiverId
          };
          this.sendMessage(msg);
        }
        this.setState({isReconnecting : true});
      }else if (state === "disconnected"){
        this.setState({isReconnecting : true});
      }else if (state === "connected"){
        this.setState({isReconnecting : false});
      }
    });


    const offer = await this.peerConnection.createOffer();
    console.log('Offer' + offer);
      try {
        const message = {
          role: this.props.isCustomer ? "share" : "viewer",
          id: "sdpOffer",
          sdpOffer: offer,
          userId: this.id,
          receiverId: this.receiverId,
          callID: this.props.callID
        };
        this.sendMessage(message);
      } catch (e) {}
    //}
  }

  async processOffer(message) {
    let offer = message.sdpOffer;

    const answer = await this.peerConnection.processOffer(offer);
    console.log("processOffer " + answer);
    const msg = {
      role: this.props.isCustomer ? "share" : "viewer",
      id: "sdpAnswer",
      sdpAnswer: answer,
      userId: this.id,
      receiverId: this.receiverId,
      callID: this.props.callID
    };
    this.sendMessage(msg);
  }

  async processAnswer(answer){
    await this.peerConnection.processAnswer(answer);
  }

  async handleIceCandidate(candidate){
    await this.peerConnection.handleIceCandidate(candidate);
  }


  sendMessage(msg) {
    this.rws.send(JSON.stringify(msg), error => {
      if (error) {
        console.log(
          `client: Websocket error '${error}' on message '${msg.id}'`,
          { topic: "ws" }
        );
      }
    });
  }

}

export default Customer;